import { render, staticRenderFns } from "./NameChipValueFlex.vue?vue&type=template&id=9cfc6e8a&scoped=true&"
import script from "./NameChipValueFlex.vue?vue&type=script&setup=true&lang=js&"
export * from "./NameChipValueFlex.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfc6e8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
